import React from 'react';
import LaptopImg from '../assets/laptop.jpg'
import ServidorImg from '../assets/Servidor.png'
import AccesorioImg from '../assets/Accesorios.jpg'
import AnimatedSection from '../components/AnimatedSection'


const productos = [
  {
    nombre: 'Laptops',
    descripcion: 'Portátiles de alto rendimiento para trabajo o entretenimiento.',
    imagen: LaptopImg,
  },
  {
    nombre: 'Servidores',
    descripcion: 'Soluciones de infraestructura robustas para empresas.',
    imagen: ServidorImg,
  },
  {
    nombre: 'Accesorios',
    descripcion: 'Periféricos y gadgets para potenciar tu experiencia tecnológica.',
    imagen: AccesorioImg,
  },
];

export default function Equipos() {
  return (
    <section id="equipos" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 text-center">
        <h2 className="text-3xl font-bold mb-12">Nuestros Equipos</h2>
        <AnimatedSection>
            <div className="grid gap-8 md:grid-cols-3">
            {productos.map((item, idx) => (
                <div key={idx} className="bg-white rounded-xl shadow-md overflow-hidden">
                <img src={item.imagen} alt={item.nombre} className="w-full h-48 object-cover" />
                <div className="p-6">
                    <h3 className="text-xl font-semibold mb-2">{item.nombre}</h3>
                    <p className="text-gray-600">{item.descripcion}</p>
                </div>
                </div>
            ))}
            </div>
        </AnimatedSection>
      </div>
    </section>
  );
}
